var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67267 0.26006C1.26402 -0.111447 0.631567 -0.0813304 0.26006 0.327327C-0.111447 0.735985 -0.0813304 1.36843 0.327327 1.73994L1.67267 0.26006ZM6.5 6L5.82733 6.73994C6.20875 7.08669 6.79125 7.08669 7.17267 6.73994L6.5 6ZM12.6727 1.73994C13.0813 1.36843 13.1114 0.735985 12.7399 0.327327C12.3684 -0.0813304 11.736 -0.111447 11.3273 0.26006L12.6727 1.73994ZM0.327327 1.73994L5.82733 6.73994L7.17267 5.26006L1.67267 0.26006L0.327327 1.73994ZM7.17267 6.73994L12.6727 1.73994L11.3273 0.26006L5.82733 5.26006L7.17267 6.73994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownArrow);
export default __webpack_public_path__ + "static/media/dropDownArrow.2ce528ad70ee41c74fbf99602406c361.svg";
export { ForwardRef as ReactComponent };